import permissions from "../db/permissions";
import { useProject } from "./useProject";
import { useUser } from "./useUser";

export const useCan = () => {
  const user = useUser();
  const { project } = useProject();

  const doThat = (action, rest, manualCheck) => {
    if (!user || !user?.role?.name || !action) return false;

    const { scopes } = user;

    const { name: role } = user?.role;

    if (!role) return false;

    if (role === "admin") return true;

    const [what, which] = action.split(":");

    const permission =
      scopes?.[what?.toUpperCase()]?.includes(which) ||
      permissions[what][which];

    if (!permission) return false;

    if (Array.isArray(permission)) {
      return permission.includes(role) || manualCheck;
    }

    if (typeof permission === "object") {
      const { ownCompany, ownProject } = permission;

      if (ownCompany && ownCompany.includes(role)) {
        return (
          String(rest?.company_id) === String(user.company?.id) || manualCheck
        );
      }

      if (ownProject && ownProject.includes(role)) {
        return String(project?.id) === String(rest?.project_id) || manualCheck;
      }
    }

    if (typeof permission === "boolean") return permission;

    return false;
  };

  return { doThat };
};
